import { Component } from '@angular/core';
import {MainService} from '../../service/main.service';
import {ProfileService} from '../../service/profile.service';
import {Router} from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { session } from '../../../../environments/environment.session';
import { Utf8EncodingService } from 'src/app/md/service/utf8-encoding.service';
  @Component({
  selector: '[app-portal-sidebar]',
  templateUrl: './portal-sidebar.component.html',
  styleUrls: ['./portal-sidebar.component.css']
})
export class PortalSidebarComponent{

  user_id:any;
  imgURL:any;
  erpUser:any;
  userInfo:any={emp_name:'Ram Prasad',designation:'Accountant'}
  constructor( private router:Router, private utf8EncodingService:Utf8EncodingService,private profileService: ProfileService,private sanitizer: DomSanitizer, private mainService: MainService) {}
  hidden=true;
  accInfo={account_name:'NA'}
  async ngOnInit() {
    this.erpUser = this.utf8EncodingService.decodeFromUtf8((session['erpUser'] as any ));;
    this.user_id = this.erpUser.user_id;
    if(this.erpUser.is_admin==0){
      this.hidden=true;
    }else{
      this.hidden=false
    }
    // this.imgURL = './assets/img/admin-avatar.png';
  }




  async getUserImage(){
    const res = await this.profileService.getImage(this.user_id);
    if (res) {
      const unsafeImageUrl = window.URL.createObjectURL(res); // URL.createObjectURL(res);
      this.imgURL = this.sanitizer.bypassSecurityTrustUrl(unsafeImageUrl);
      this.mainService.profileImageUrl=this.imgURL;

    }
  }
  async getUserInfo(){
    var resp= await this.profileService.getUserProfileInfo(this.user_id);
    console.log(resp);
    if(resp['error']==false){
      this.userInfo=this.erpUser;
    }else{

    }
  }

  async getAccImage() {
    const res = await this.profileService.getAccImage(this.erpUser.b_acct_id);
    if (res) {
      const unsafeImageUrl = window.URL.createObjectURL(res); // URL.createObjectURL(res);
      this.imgURL = this.sanitizer.bypassSecurityTrustUrl(unsafeImageUrl);
      this.mainService.accountImageUrl = this.imgURL;

    }
  }
  async getAccInfo() {
    var resp = await this.profileService.getaccountmodule(this.erpUser.b_acct_id);
    console.log(resp);
    if (resp['error'] == false) {
      this.accInfo = resp.data[0];
      this.mainService.accInfo = this.accInfo;
    } else {

    }

  }

}
